import { Link } from "react-router-dom";
import { Inbox, Table2 } from "lucide-react";

const TABS = [
  { key: "enquiries", label: "Enquiries", to: "/admin", icon: Inbox },
  { key: "prices", label: "Price Sheet", to: "/admin/prices", icon: Table2 },
];

export function AdminTabs({ active }) {
  return (
    <div className="inline-flex gap-1 p-1 rounded-full border border-ib-steel/30 bg-ib-surface/50 mb-8" data-testid="admin-tabs">
      {TABS.map(({ key, label, to, icon: Icon }) => (
        <Link key={key} to={to} data-testid={`admin-tab-${key}`}
          className={`inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full font-outfit text-xs transition-colors ${active === key ? "bg-ib-blue text-white" : "text-ib-text-secondary hover:text-ib-text"}`}>
          <Icon className="w-3.5 h-3.5" /> {label}
        </Link>
      ))}
    </div>
  );
}
